import { FormControl, FormLabel, Switch } from '@apollo/orbit';
import classnames from 'classnames';
import { uniqueId } from 'lodash';
import React, { useMemo } from 'react';

interface EmailPreferenceRowProps {
  name: string;
  description: string;
  isToggled: boolean;
  onToggle: () => void;
  disabled?: boolean;
}

export const EmailPreferenceRow = ({
  name,
  description,
  isToggled,
  onToggle,
  disabled,
}: EmailPreferenceRowProps) => {
  const idRef = useMemo(() => uniqueId('email-preference-row-toggle-'), []);
  const describedById = `${idRef}-description`;

  return (
    <FormControl isDisabled={disabled}>
      <Switch
        aria-label={name}
        isChecked={isToggled}
        onChange={onToggle}
        isDisabled={disabled}
      >
        <FormLabel className="normal-case">{name}</FormLabel>
        <div
          aria-hidden
          className={classnames(
            'mt-1 text-sm font-normal normal-case',
            disabled ? 'text-disabled' : 'text-secondary',
          )}
          id={describedById}
        >
          {description}
        </div>
      </Switch>
    </FormControl>
  );
};
